import { createApi } from '@reduxjs/toolkit/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const articlesCommentsApi = createApi({
  reducerPath: 'articlesCommentsApi',
  baseQuery: rtkBaseQuery('/staff/Comment'),
  tagTypes: ['Articles'],

  endpoints: (builder) => ({
    createComment: builder.mutation({
      query: (body) => ({
        url: '/Create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Articles'],
    }),
    deleteComment: builder.mutation({
      query: (id) => ({
        url: `/Delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Articles'],
    }),
    editComment: builder.mutation({
      query: (body) => ({
        url: '/Update',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Articles'],
    }),
    getCommentsById: builder.query({
      query: ({ id }) => ({
        url: `/GetById/${id}`,
      }),
      providesTags: ['Articles'],
    }),
    getAllComments: builder.query({
      query: () => '/GetAll',
      providesTags: ['Articles'],
    }),
    getCommentsByArticle: builder.query({
      query: ({ articleId, page, limit }) => ({
        url: `/GetCommentByArticle?articleId=${articleId}&page=${page}&limit=${limit}`,
      }),
      providesTags: ['Articles'],
    }),
    updateComment: builder.mutation({
      query: (body) => ({
        url: '/Update',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Articles'],
    }),
  }),
});

export const {
  useCreateCommentMutation,
  useDeleteCommentMutation,
  useEditCommentMutation,
  useLazyGetCommentsByIdQuery,
  useGetAllCommentsQuery,
  useGetCommentsByArticleQuery,
  useUpdateCommentMutation,
} = articlesCommentsApi;
